import { render } from "./DetailGlobalResponse.vue?vue&type=template&id=1f1c897f&scoped=true"
import script from "./DetailGlobalResponse.vue?vue&type=script&lang=js"
export * from "./DetailGlobalResponse.vue?vue&type=script&lang=js"

import "./DetailGlobalResponse.vue?vue&type=style&index=0&id=1f1c897f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f1c897f"]])

export default __exports__